/* eslint-disable camelcase */
import AppRoutes from 'src/features/router/data/app-routes';
import { APP_IDP_URL, APP_IDP_CLIENTID, APP_BASE_URL } from 'src/features/shared/data/app-settings';

export const OIDC_CONFIG = {
    authority: APP_IDP_URL ?? '',
    client_id: APP_IDP_CLIENTID ?? '',
    redirect_uri: `${APP_BASE_URL}${AppRoutes.loginSuccessfullPath}`,
    post_logout_redirect_uri: `${APP_BASE_URL}${AppRoutes.loginSuccessfullPath}`,
    silent_redirect_uri: ``,
    response_type: 'code',
    scope: 'openid profile roles email SD.LockerPlugin.Backoffice.API',
    monitorSession: true,
    revokeTokensOnSignout: true,
};

export enum UserRole {
    'SD.LockerPlugin.Admin' = 1,
}
